import * as Yup from "yup";
import {yupRequiredString} from "../yup/Validators";

export const ResourceTypeValidationSchema = Yup.object().shape({
  label: yupRequiredString
})
